import { HTMLAttributes } from 'react'
import { styled } from 'styled-components'

export const SvgIcon = styled.svg`
	fill: ${({ theme }) =>
		theme.darkMode
			? theme.colors.extended.grey[100]
			: theme.colors.bases.primary[700]};
	path.inner-icon {
		fill: ${({ theme }) =>
			theme.darkMode
				? theme.colors.bases.primary[700]
				: theme.colors.extended.grey[100]};
	}
`

export const ArrowCircleIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="18"
		height="16"
		viewBox="0 0 18 16"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.1001 2C7.00734 2 4.50013 4.50721 4.50013 7.6C4.50013 8.41379 4.67309 9.18451 4.98331 9.87959C5.20839 10.3839 4.98202 10.9752 4.47768 11.2003C3.97335 11.4254 3.38203 11.199 3.15695 10.6947C2.73448 9.74812 2.50013 8.70009 2.50013 7.6C2.50013 3.40264 5.90277 0 10.1001 0C14.2975 0 17.7001 3.40264 17.7001 7.6C17.7001 11.7974 14.2975 15.2 10.1001 15.2C9.54785 15.2 9.10013 14.7523 9.10013 14.2C9.10013 13.6477 9.54785 13.2 10.1001 13.2C13.1929 13.2 15.7001 10.6928 15.7001 7.6C15.7001 4.50721 13.1929 2 10.1001 2Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.49433 6.41614C6.96217 6.70966 7.10348 7.32685 6.80997 7.79468L4.89674 10.8442C4.60322 11.312 3.98603 11.4533 3.5182 11.1598L0.468679 9.2466C0.000845581 8.95309 -0.140469 8.3359 0.153044 7.86806C0.446558 7.40023 1.06375 7.25891 1.53159 7.55243L3.73401 8.93421L5.11579 6.73178C5.4093 6.26394 6.0265 6.12263 6.49433 6.41614Z"
		/>
	</SvgIcon>
)

export const ArrowRightIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="#212529"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.91877 0.667113C7.32348 0.29131 7.95621 0.314745 8.33201 0.719455L13.532 6.31945C13.8883 6.70314 13.8883 7.29668 13.532 7.68036L8.33201 13.2804C7.95621 13.6851 7.32348 13.7085 6.91877 13.3327C6.51406 12.9569 6.49062 12.3242 6.86643 11.9195L11.4346 6.99991L6.86643 2.08036C6.49062 1.67565 6.51406 1.04292 6.91877 0.667113Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.199219 6.99991C0.199219 6.44762 0.646934 5.99991 1.19922 5.99991L12.7992 5.99991C13.3515 5.99991 13.7992 6.44762 13.7992 6.9999C13.7992 7.55219 13.3515 7.9999 12.7992 7.9999L1.19922 7.99991C0.646934 7.99991 0.199219 7.55219 0.199219 6.99991Z"
		/>
	</SvgIcon>
)

export const ArrowDownIcon = styled(ArrowRightIcon)`
	transform: rotate(90deg);
`

export const CarretDownIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="14"
		height="8"
		viewBox="0 0 14 8"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path d="M7.70701 7.29289L13.2928 1.70711C13.9228 1.07714 13.4766 0 12.5857 0H1.41412C0.523211 0 0.0770421 1.07714 0.707007 1.70711L6.2928 7.29289C6.68332 7.68342 7.31648 7.68342 7.70701 7.29289Z" />
	</SvgIcon>
)

export const CarretUpIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="14"
		height="8"
		viewBox="0 0 14 8"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			d="M7.70701 7.29289L13.2928 1.70711C13.9228 1.07714 13.4766 0 12.5857 0H1.41412C0.523211 0 0.0770421 1.07714 0.707007 1.70711L6.2928 7.29289C6.68332 7.68342 7.31648 7.68342 7.70701 7.29289Z"
			transform="scale(1,-1) translate(0,-8)"
		/>
	</SvgIcon>
)

export const CheckmarkIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="24"
		height="12"
		viewBox="0 0 16 12"
		fill="#3CB053"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.7109 0.697112C16.0993 1.08974 16.0959 1.7229 15.7033 2.11131L6.39385 11.3207C6.00272 11.7077 5.37249 11.706 4.98346 11.3169L0.292893 6.62637C-0.0976311 6.23584 -0.0976311 5.60268 0.292893 5.21215C0.683417 4.82163 1.31658 4.82163 1.70711 5.21215L5.69437 9.19942L14.2967 0.689476C14.6894 0.301066 15.3225 0.304485 15.7109 0.697112Z"
		/>
	</svg>
)

export const ChevronIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		viewBox="0 0 24 24"
		width="24"
		height="24"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.24744 4.34151C7.61112 3.92587 8.24288 3.88375 8.65852 4.24744L16.6585 11.2474C16.8755 11.4373 17 11.7116 17 12C17 12.2884 16.8755 12.5627 16.6585 12.7526L8.65852 19.7526C8.24288 20.1163 7.61112 20.0742 7.24744 19.6585C6.88375 19.2429 6.92587 18.6111 7.34151 18.2474L14.4814 12L7.34151 5.75259C6.92587 5.38891 6.88375 4.75715 7.24744 4.34151Z"
		/>
	</SvgIcon>
)

export const RotatingChevronIcon = styled(ChevronIcon).withConfig({
	shouldForwardProp: (prop) => prop !== 'isOpen',
})<{ isOpen: boolean }>`
	vertical-align: middle;
	transform: ${({ isOpen }) => (isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
	transition: transform 0.15s ease-in-out;
`

export const CircledArrowIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="40"
		height="40"
		viewBox="0 0 45 45"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z"
		/>
		<path
			className="inner-icon"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M23.1195 13.6676C23.5243 13.2918 24.157 13.3152 24.5328 13.7199L29.7328 19.3199C30.0891 19.7036 30.0891 20.2972 29.7328 20.6808L24.5328 26.2808C24.157 26.6856 23.5243 26.709 23.1195 26.3332C22.7148 25.9574 22.6914 25.3247 23.0672 24.9199L27.6354 20.0004L23.0672 15.0808C22.6914 14.6761 22.7148 14.0434 23.1195 13.6676Z"
		/>
		<path
			className="inner-icon"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 20.0004C10 19.4481 10.4477 19.0004 11 19.0004L29 19.0004C29.5523 19.0004 30 19.4481 30 20.0004C30 20.5527 29.5523 21.0004 29 21.0004L11 21.0004C10.4477 21.0004 10 20.5527 10 20.0004Z"
		/>
	</SvgIcon>
)

export const CircledInfoIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		viewBox="0 0 20 20"
		width="20"
		height="20"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM20 10C20 15.5229 15.5228 20 10 20C4.47715 20 -4.82823e-07 15.5228 0 10C4.82823e-07 4.47715 4.47715 -4.82823e-07 10 0C15.5229 4.82823e-07 20 4.47715 20 10Z"
		/>
		<path d="M9 6.00003C9 5.44774 9.44772 5.00003 10 5.00003C10.5523 5.00003 11 5.44774 11 6.00003C11 6.55231 10.5523 7.00003 10 7.00003C9.44772 7.00003 9 6.55231 9 6.00003Z" />
		<path d="M11 14.6C11 15.1523 10.5523 15.6 10 15.6C9.44772 15.6 9 15.1523 9 14.6L9 9.4C9 8.84772 9.44772 8.4 10 8.4C10.5523 8.4 11 8.84772 11 9.4L11 14.6Z" />
	</SvgIcon>
)

export const CircledPlusIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM22 12C22 17.5229 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5229 2 22 6.47715 22 12Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.2 12C17.2 12.5523 16.7523 13 16.2 13L7.8 13C7.24771 13 6.8 12.5523 6.8 12C6.8 11.4477 7.24771 11 7.8 11L16.2 11C16.7523 11 17.2 11.4477 17.2 12Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 17.2C11.4477 17.2 11 16.7523 11 16.2L11 7.8C11 7.24772 11.4477 6.8 12 6.8C12.5523 6.8 13 7.24771 13 7.8L13 16.2C13 16.7523 12.5523 17.2 12 17.2Z"
		/>
	</SvgIcon>
)

export const CircleIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path d="M8 3L8.52264 3.02739L9.03956 3.10926L9.54508 3.24472L10.0337 3.43227L10.5 3.66987L10.9389 3.95492L11.3457 4.28428L11.7157 4.65435L12.0451 5.06107L12.3301 5.5L12.5677 5.96632L12.7553 6.45492L12.8907 6.96044L12.9726 7.47736L13 8L12.9726 8.52264L12.8907 9.03956L12.7553 9.54508L12.5677 10.0337L12.3301 10.5L12.0451 10.9389L11.7157 11.3457L11.3457 11.7157L10.9389 12.0451L10.5 12.3301L10.0337 12.5677L9.54508 12.7553L9.03956 12.8907L8.52264 12.9726L8 13L7.47736 12.9726L6.96044 12.8907L6.45492 12.7553L5.96632 12.5677L5.5 12.3301L5.06107 12.0451L4.65435 11.7157L4.28428 11.3457L3.95492 10.9389L3.66987 10.5L3.43227 10.0337L3.24472 9.54508L3.10926 9.03956L3.02739 8.52264L3 8L3.02739 7.47736L3.10926 6.96044L3.24472 6.45492L3.43227 5.96632L3.66987 5.5L3.95492 5.06107L4.28428 4.65435L4.65435 4.28428L5.06107 3.95492L5.5 3.66987L5.96632 3.43227L6.45492 3.24472L6.96044 3.10926L7.47736 3.02739L8 3Z" />
	</SvgIcon>
)

export const ClockIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="20"
		height="20"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 3.85C10.5523 3.85 11 4.29771 11 4.85V9.95C11 10.5023 10.5523 10.95 10 10.95C9.44771 10.95 9 10.5023 9 9.95V4.85C9 4.29771 9.44771 3.85 10 3.85Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.43058 12.1087C5.19894 11.6073 5.4176 11.0131 5.91896 10.7815L9.55013 9.10383C10.0515 8.87219 10.6457 9.09084 10.8773 9.5922C11.109 10.0936 10.8903 10.6878 10.389 10.9194L6.75779 12.5971C6.25643 12.8287 5.66222 12.6101 5.43058 12.1087Z"
		/>
	</SvgIcon>
)

export const CrossIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.69372 17.2999C6.30319 16.9094 6.30319 16.2762 6.69372 15.8857L15.8861 6.69328C16.2766 6.30276 16.9098 6.30276 17.3003 6.69328C17.6908 7.08381 17.6908 7.71697 17.3003 8.1075L8.10793 17.2999C7.71741 17.6904 7.08424 17.6904 6.69372 17.2999Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.66399 6.69331C7.05451 6.30278 7.68768 6.30278 8.0782 6.69331L17.2706 15.8857C17.6611 16.2762 17.6611 16.9094 17.2706 17.2999C16.8801 17.6904 16.2469 17.6904 15.8564 17.2999L6.66399 8.10752C6.27346 7.71699 6.27346 7.08383 6.66399 6.69331Z"
		/>
	</SvgIcon>
)

export const EditIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.6713 4.34045C17.1223 3.79142 16.1035 3.9201 15.3957 4.62786L14.0118 6.01178L17.9882 9.98822L19.3721 8.6043C20.0799 7.89653 20.2086 6.8777 19.6595 6.32867L17.6713 4.34045ZM16.4882 11.4882L12.5118 7.51178L5.26693 14.7566C4.94924 15.0743 4.73441 15.4722 4.66412 15.8732L4.00634 19.625C3.96438 19.8643 4.13568 20.0356 4.37496 19.9937L8.12685 19.3359C8.52777 19.2656 8.92567 19.0508 9.24336 18.7331L16.4882 11.4882Z"
		/>
	</SvgIcon>
)

export const ErrorIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="20"
		height="19"
		viewBox="0 0 20 19"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 0C10.3704 0 10.7105 0.204749 10.8838 0.532112L19.8838 17.5321C20.0479 17.8421 20.0376 18.2153 19.8567 18.5158C19.6758 18.8163 19.3507 19 19 19H1C0.649283 19 0.324198 18.8163 0.143295 18.5158C-0.0376073 18.2153 -0.0478841 17.8421 0.116212 17.5321L9.11621 0.532112C9.28952 0.204749 9.62959 0 10 0ZM2.66091 17H17.3391L10 3.13727L2.66091 17Z"
		/>
		<path d="M11 14.5C11 15.0579 10.5579 15.5 10 15.5C9.44214 15.5 9 15.0579 9 14.5C9 13.9421 9.44214 13.5 10 13.5C10.5579 13.5 11 13.9421 11 14.5Z" />
		<path d="M8.99999 7.5C8.99999 6.94214 9.44212 6.5 9.99998 6.5C10.5578 6.5 11 6.94214 11 7.5V11C11 11.5579 10.5576 12 9.99969 12C9.44183 12 8.99999 11.5579 8.99999 11V7.5Z" />
	</SvgIcon>
)

export const ExternalLinkIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="14"
		height="14"
		viewBox="0 0 14 14"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.69372 17.2999C6.30319 16.9094 6.30319 16.2762 6.69372 15.8857L15.8861 6.69328C16.2766 6.30276 16.9098 6.30276 17.3003 6.69328C17.6908 7.08381 17.6908 7.71697 17.3003 8.1075L8.10793 17.2999C7.71741 17.6904 7.08424 17.6904 6.69372 17.2999Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.292969 2.83301C0.292969 1.45229 1.41226 0.333008 2.79297 0.333008H4.6388C5.09904 0.333008 5.47214 0.706104 5.47214 1.16634C5.47214 1.62658 5.09904 1.99967 4.6388 1.99967H2.79297C2.33273 1.99967 1.95964 2.37277 1.95964 2.83301V11.208C1.95964 11.6682 2.33273 12.0413 2.79297 12.0413L11.168 12.0413C11.6282 12.0413 12.0013 11.6682 12.0013 11.208V9.36217C12.0013 8.90194 12.3744 8.52884 12.8346 8.52884C13.2949 8.52884 13.668 8.90194 13.668 9.36217V11.208C13.668 12.5887 12.5487 13.708 11.168 13.708L2.79297 13.708C1.41226 13.708 0.292969 12.5887 0.292969 11.208V2.83301ZM7.83464 1.99967C7.3744 1.99967 7.0013 1.62658 7.0013 1.16634C7.0013 0.706104 7.3744 0.333008 7.83464 0.333008H12.8346C13.2949 0.333008 13.668 0.706104 13.668 1.16634V6.16634C13.668 6.62658 13.2949 6.99967 12.8346 6.99967C12.3744 6.99967 12.0013 6.62658 12.0013 6.16634V3.17819L8.42389 6.7556C8.09845 7.08103 7.57082 7.08103 7.24538 6.7556C6.91994 6.43016 6.91994 5.90252 7.24538 5.57709L10.8228 1.99967H7.83464Z"
		/>
	</SvgIcon>
)

export const EyeIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="16"
		height="16"
		viewBox="0 0 576 512"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		{/* Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. */}
		<path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
	</SvgIcon>
)

export const GithubIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="18"
		height="18"
		viewBox="15 15 34 34"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32,16c-8.8,0-16,7.2-16,16c0,7.1,4.6,13.1,10.9,15.2 c0.8,0.1,1.1-0.3,1.1-0.8c0-0.4,0-1.4,0-2.7c-4.5,1-5.4-2.1-5.4-2.1c-0.7-1.8-1.8-2.3-1.8-2.3c-1.5-1,0.1-1,0.1-1 c1.6,0.1,2.5,1.6,2.5,1.6c1.4,2.4,3.7,1.7,4.7,1.3c0.1-1,0.6-1.7,1-2.1c-3.6-0.4-7.3-1.8-7.3-7.9c0-1.7,0.6-3.2,1.6-4.3 c-0.2-0.4-0.7-2,0.2-4.2c0,0,1.3-0.4,4.4,1.6c1.3-0.4,2.6-0.5,4-0.5c1.4,0,2.7,0.2,4,0.5c3.1-2.1,4.4-1.6,4.4-1.6 c0.9,2.2,0.3,3.8,0.2,4.2c1,1.1,1.6,2.5,1.6,4.3c0,6.1-3.7,7.5-7.3,7.9c0.6,0.5,1.1,1.5,1.1,3c0,2.1,0,3.9,0,4.4 c0,0.4,0.3,0.9,1.1,0.8C43.4,45.1,48,39.1,48,32C48,23.2,40.8,16,32,16z"
		/>
	</svg>
)

export const HelpIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="17"
		height="17"
		viewBox="0 0 17 17"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.33301 0C12.9353 0 16.6668 3.73078 16.667 8.33301C16.667 12.9354 12.9354 16.667 8.33301 16.667C3.73078 16.6668 0 12.9353 0 8.33301C0.000175701 3.73089 3.73089 0.000175704 8.33301 0ZM8.30078 11.3135C7.83552 11.3136 7.45826 11.691 7.45801 12.1562C7.45801 12.6217 7.83536 12.9999 8.30078 13C8.76626 13 9.14355 12.6217 9.14355 12.1562C9.1433 11.691 8.76611 11.3135 8.30078 11.3135ZM8.29688 3.68457C7.4824 3.68457 6.84617 3.92354 6.37891 4.31836C5.92447 4.7024 5.69586 5.17745 5.58008 5.54492C5.44193 5.98374 5.6853 6.45145 6.12402 6.58984C6.56291 6.72813 7.03152 6.48472 7.16992 6.0459C7.22341 5.87612 7.31252 5.71128 7.45508 5.59082C7.58445 5.48167 7.82413 5.35171 8.29102 5.35059C8.29586 5.35075 8.30711 5.35139 8.32324 5.35254C8.35571 5.35485 8.40748 5.35948 8.47168 5.37012C8.60458 5.39218 8.76957 5.4349 8.92383 5.51172C9.07488 5.58695 9.1998 5.68698 9.28906 5.82031C9.37471 5.94829 9.46092 6.15602 9.46094 6.50684C9.46094 6.79242 9.30425 7.05714 9.04883 7.2959C8.92712 7.40965 8.80198 7.4985 8.70703 7.55859C8.66047 7.58806 8.62282 7.60938 8.59961 7.62207C8.59522 7.62447 8.59117 7.62618 8.58789 7.62793C8.09266 7.84352 7.77455 8.17503 7.60254 8.54688C7.44193 8.89411 7.44228 9.21061 7.44238 9.31836V9.62793C7.44238 10.0881 7.8153 10.4617 8.27539 10.4619C8.73563 10.4619 9.10938 10.0882 9.10938 9.62793V9.3252C9.10939 9.26184 9.11313 9.25166 9.11523 9.24707C9.11545 9.2466 9.11595 9.2449 9.11719 9.24316C9.1185 9.24134 9.12207 9.23693 9.12891 9.23047C9.14227 9.21787 9.18011 9.18735 9.26367 9.15234C9.27711 9.14671 9.29058 9.14012 9.30371 9.13379L8.94141 8.38379C9.30311 9.13413 9.30441 9.13392 9.30469 9.13379L9.30566 9.13281L9.30859 9.13184L9.31641 9.12793L9.33691 9.11719C9.35307 9.10891 9.37417 9.09778 9.39941 9.08398C9.4501 9.05627 9.51859 9.01746 9.59863 8.9668C9.75724 8.8664 9.97016 8.71494 10.1865 8.5127C10.6073 8.11936 11.127 7.44566 11.127 6.50684C11.1269 5.86322 10.9635 5.32503 10.6748 4.89355C10.3897 4.46751 10.0152 4.19397 9.66699 4.02051C9.32194 3.84866 8.98672 3.76668 8.74512 3.72656C8.62233 3.70618 8.51809 3.69589 8.44141 3.69043C8.40298 3.6877 8.37108 3.68538 8.34668 3.68457H8.29688Z"
		/>
	</SvgIcon>
)

export const HexagonIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path d="M8 3L12.3301 5.5V10.5L8 13L3.66987 10.5V5.5L8 3Z" />
	</SvgIcon>
)

export const InfoIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="17"
		height="17"
		viewBox="0 0 17 17"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.3125 16.625C12.9034 16.625 16.625 12.9034 16.625 8.3125C16.625 3.72163 12.9034 -4.01346e-07 8.3125 0C3.72163 4.01347e-07 -4.01347e-07 3.72163 0 8.3125C4.01346e-07 12.9034 3.72163 16.625 8.3125 16.625ZM8.29167 13C8.75191 13 9.125 12.6269 9.125 12.1667V7.41667C9.125 6.95643 8.75191 6.58334 8.29167 6.58334C7.83143 6.58334 7.45834 6.95643 7.45834 7.41667V12.1667C7.45834 12.6269 7.83143 13 8.29167 13ZM8.29167 3.66667C7.83143 3.66667 7.45834 4.03976 7.45834 4.5C7.45834 4.96024 7.83143 5.33334 8.29167 5.33334C8.75191 5.33334 9.125 4.96024 9.125 4.5C9.125 4.03976 8.75191 3.66667 8.29167 3.66667Z"
		/>
	</SvgIcon>
)

export const LinkIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		width="18"
		height="18"
		viewBox="0 0 19 19"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
		{...props}
	>
		<path d="M5.86163 12.3234C5.50186 11.9636 5.50186 11.3803 5.86163 11.0205L11.1621 5.72005C11.5219 5.36027 12.1052 5.36027 12.465 5.72004C12.8248 6.07982 12.8248 6.66313 12.465 7.02291L7.1645 12.3234C6.80472 12.6832 6.22141 12.6832 5.86163 12.3234Z" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.13116 1.57788C11.2021 -0.517338 14.5825 -0.527194 16.6656 1.5559C18.7464 3.6367 18.7392 7.01257 16.6495 9.08447L14.3356 11.3787C13.9434 11.7675 13.3102 11.7648 12.9214 11.3726C12.5325 10.9805 12.5352 10.3473 12.9274 9.95844L15.2413 7.66422C16.5442 6.37239 16.5487 4.26751 15.2513 2.97012C13.9525 1.67129 11.8448 1.67744 10.5536 2.98382L8.26771 5.29653C7.87947 5.68933 7.24632 5.69302 6.85352 5.30478C6.46072 4.91655 6.45703 4.28339 6.84527 3.89059L9.13116 1.57788ZM5.4128 6.66066C5.80376 7.05075 5.80448 7.68391 5.41439 8.07488L2.97337 10.5214C1.67451 11.8232 1.67569 13.9311 2.97602 15.2314C4.27913 16.5345 6.3925 16.5325 7.69314 15.2269L10.123 12.7878C10.5128 12.3965 11.146 12.3953 11.5373 12.7851C11.9285 13.1749 11.9297 13.8081 11.5399 14.1993L9.11003 16.6385C7.02878 18.7276 3.64701 18.7308 1.56181 16.6456C-0.518946 14.5649 -0.520844 11.1919 1.55757 9.10878L3.99859 6.66225C4.38867 6.27129 5.02184 6.27058 5.4128 6.66066Z"
		/>
	</svg>
)

export const PhoneIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		width="18"
		height="18"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
		{...props}
	>
		<path d="M18.0404 13.6386L15.2125 13.3157C14.5333 13.2378 13.8653 13.4716 13.3866 13.9503L11.338 15.9989C8.18723 14.3956 5.60425 11.8238 4.00102 8.66188L6.06073 6.60218C6.53947 6.12344 6.77327 5.45543 6.69534 4.77628L6.37246 1.97063C6.23886 0.846148 5.29251 0 4.15689 0H2.23079C0.972707 0 -0.0738448 1.04655 0.00408987 2.30464C0.594167 11.8127 8.19836 19.4057 17.6953 19.9958C18.9533 20.0737 19.9999 19.0272 19.9999 17.7691V15.843C20.011 14.7185 19.1649 13.7722 18.0404 13.6386Z" />
	</SvgIcon>
)

export const ReturnIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="16"
		height="13"
		viewBox="0 0 16 13"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1 0C1.55228 0 2 0.447715 2 1V6.65C2 7.20228 2.44772 7.65 3 7.65H15C15.5523 7.65 16 8.09771 16 8.65C16 9.20228 15.5523 9.65 15 9.65H3C1.34314 9.65 0 8.30685 0 6.65V1C0 0.447715 0.447715 0 1 0Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.5407 4.69739C11.9564 4.33371 12.5881 4.37582 12.9518 4.79146L15.7518 7.99146C16.0817 8.36849 16.0817 8.93144 15.7518 9.30847L12.9518 12.5085C12.5881 12.9241 11.9564 12.9662 11.5407 12.6025C11.1251 12.2389 11.083 11.6071 11.4467 11.1915L13.6705 8.64997L11.4467 6.10847C11.083 5.69283 11.1251 5.06107 11.5407 4.69739Z"
		/>
	</SvgIcon>
)

export const ReturnLeftIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		width="16"
		height="13"
		viewBox="0 0 16 13"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9 10.85H13C13.5523 10.85 14 10.4023 14 9.84999V6.19999C14 5.64771 13.5523 5.19999 13 5.19999L1 5.19999C0.447717 5.19999 2.09749e-06 4.75227 2.14577e-06 4.19999C2.19405e-06 3.64771 0.447717 3.19999 1 3.19999L13 3.19999C14.6569 3.19999 16 4.54314 16 6.19999L16 9.84999C16 11.5068 14.6569 12.85 13 12.85H9C8.44772 12.85 8 12.4023 8 11.85C8 11.2977 8.44772 10.85 9 10.85Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.4585 8.15259C4.04287 8.51627 3.41111 8.47415 3.04742 8.05852L0.247423 4.85852C-0.0824745 4.48149 -0.0824744 3.91853 0.247423 3.54151L3.04742 0.341509C3.41111 -0.0741273 4.04287 -0.116245 4.45851 0.247437C4.87414 0.611119 4.91626 1.24288 4.55258 1.65852L2.32877 4.20001L4.55258 6.74151C4.91626 7.15715 4.87414 7.78891 4.4585 8.15259Z"
		/>
	</SvgIcon>
)

export function SearchIcon({ ...props }) {
	return (
		<SvgIcon
			{...props}
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.25 2C3.90279 2 2 3.90279 2 6.25C2 8.59721 3.90279 10.5 6.25 10.5C8.59721 10.5 10.5 8.59721 10.5 6.25C10.5 3.90279 8.59721 2 6.25 2ZM0 6.25C0 2.79822 2.79822 0 6.25 0C9.70178 0 12.5 2.79822 12.5 6.25C12.5 9.70178 9.70178 12.5 6.25 12.5C2.79822 12.5 0 9.70178 0 6.25Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.2927 15.7071L9.23719 10.6515L10.6514 9.23731L15.707 14.2929C16.0975 14.6834 16.0975 15.3166 15.707 15.7071C15.3164 16.0976 14.6833 16.0976 14.2927 15.7071Z"
			/>
		</SvgIcon>
	)
}

export const SuccessIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		viewBox="0 0 20 20"
		width="20"
		height="20"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.261 6.14683C15.6494 6.53952 15.6459 7.17268 15.2532 7.56103L9.13554 13.611C8.74443 13.9978 8.11438 13.9961 7.72538 13.6072L4.643 10.5258C4.25242 10.1354 4.25232 9.50219 4.64278 9.11161C5.03324 8.72102 5.66641 8.72092 6.05699 9.11138L8.43618 11.4898L13.8468 6.13897C14.2395 5.75063 14.8727 5.75415 15.261 6.14683Z"
		/>
	</SvgIcon>
)

export const SquareIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
		className={'square-icon' + (props.className ? ' ' + props.className : '')}
	>
		<path d="M3 3H13V13H3V3Z" />
	</SvgIcon>
)

export const RhombusIcon = styled(SquareIcon)`
	transform: rotate(45deg);
`

export const TriangleIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path d="M8 3L13.1962 12H2.80385L8 3Z" />
	</SvgIcon>
)

export const WarningIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="#FFBB0C"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.72825 0.928245C9.58121 0.663907 9.30248 0.5 9 0.5C8.69752 0.5 8.41879 0.663907 8.27175 0.928245L0.855084 14.2616C0.711514 14.5197 0.715285 14.8345 0.864996 15.0891C1.01471 15.3437 1.28799 15.5 1.58333 15.5H16.4167C16.712 15.5 16.9853 15.3437 17.135 15.0891C17.2847 14.8345 17.2885 14.5197 17.1449 14.2616L9.72825 0.928245ZM8.99992 4.91667C8.53968 4.91667 8.16658 5.28976 8.16658 5.75V9.91667C8.16658 10.3769 8.53968 10.75 8.99992 10.75C9.46016 10.75 9.83325 10.3769 9.83325 9.91667V5.75C9.83325 5.28976 9.46016 4.91667 8.99992 4.91667ZM8.99992 13.4583C9.46016 13.4583 9.83325 13.0852 9.83325 12.625C9.83325 12.1648 9.46016 11.7917 8.99992 11.7917C8.53968 11.7917 8.16658 12.1648 8.16658 12.625C8.16658 13.0852 8.53968 13.4583 8.99992 13.4583Z"
		/>
	</svg>
)

export { Spinner } from './Spinner'
